import { Box } from '@mui/material';

export default function TournamentSetupTabPanel({ children, value, index }) {
  if (value !== index) return null;
  return <Box sx={{ pt: 2 }}>{children}</Box>;
}
